module.exports = __webpack_public_path__ + "media/img/sefoma_5774316-541adbeb.jpg";